import React, { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Loader2 } from "lucide-react";
import { useLang } from "@/context/LangContext";

const POSTER_URL = "https://neox.lk";

export const RoomPoster = () => {
  const { t } = useLang();
  const posterRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const download = async () => {
    if (!posterRef.current) return;
    setBusy(true);
    try {
      const html2canvas = (await import("html2canvas")).default;
      const canvas = await html2canvas(posterRef.current, { scale: 2, backgroundColor: "#1C140E", useCORS: true });
      const link = document.createElement("a");
      link.download = "neox-music-room-poster.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (e) {
      // no-op
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={download}
        disabled={busy}
        data-testid="poster-download-btn"
        className="w-full h-12 rounded-full font-ui font-bold text-sm inline-flex items-center justify-center gap-2 transition-transform hover:scale-[1.02] active:scale-95 disabled:opacity-60"
        style={{ background: "var(--card)", color: "var(--text)", border: "1px solid var(--border)" }}
      >
        {busy ? <Loader2 size={18} className="animate-spin" /> : <Download size={18} />}
        {t("poster_download")}
      </button>

      {/* Hidden printable poster (portrait, A4-ish) */}
      <div style={{ position: "fixed", left: -99999, top: 0, pointerEvents: "none" }} aria-hidden="true">
        <div
          ref={posterRef}
          style={{
            width: 794, height: 1123, background: "#1C140E", color: "#fff",
            display: "flex", flexDirection: "column", alignItems: "center",
            padding: "72px 56px", boxSizing: "border-box", textAlign: "center",
          }}
        >
          <div style={{ fontSize: 92, lineHeight: 1 }}>🪔</div>

          <div className="font-si" style={{ fontSize: 76, fontWeight: 800, color: "#F5C97A", marginTop: 20, lineHeight: 1.15 }}>
            ස්වාරාන්ජලිය
          </div>
          <div className="font-en" style={{ fontSize: 30, letterSpacing: 6, color: "rgba(255,255,255,0.75)", marginTop: 6, fontWeight: 700 }}>
            NEOX MUSIC ROOM
          </div>

          <div style={{ width: 120, height: 4, background: "#92400E", borderRadius: 4, margin: "34px 0" }} />

          <div className="font-si" style={{ fontSize: 38, fontWeight: 700, lineHeight: 1.5 }}>
            පැරණි සිංහල ගී · කතන්දර · භාවනා
          </div>
          <div className="font-en" style={{ fontSize: 26, color: "rgba(255,255,255,0.7)", marginTop: 10 }}>
            Calm old songs · Stories · Meditation
          </div>

          <div style={{ background: "#fff", borderRadius: 28, padding: 34, marginTop: 44 }}>
            <QRCodeCanvas value={POSTER_URL} size={300} bgColor="#ffffff" fgColor="#1C140E" level="M" includeMargin={false} />
          </div>

          <div className="font-si" style={{ fontSize: 34, fontWeight: 700, color: "#F5C97A", marginTop: 32 }}>
            දුරකථනයෙන් Scan කර නොමිලේ අහන්න
          </div>
          <div className="font-en" style={{ fontSize: 24, color: "rgba(255,255,255,0.7)", marginTop: 8 }}>
            Scan with your phone · Free to listen
          </div>

          <div className="font-en" style={{ fontSize: 52, fontWeight: 800, color: "#fff", marginTop: 26, letterSpacing: 2 }}>
            neox.lk
          </div>

          <div style={{ flex: 1 }} />
          <div className="font-en" style={{ fontSize: 22, color: "rgba(255,255,255,0.5)", fontWeight: 600, letterSpacing: 1 }}>
            A FutureTec Production
          </div>
        </div>
      </div>
    </>
  );
};
